import { render, staticRenderFns } from "./ysZhiShi.vue?vue&type=template&id=51e2123c&scoped=true&"
import script from "./ysZhiShi.vue?vue&type=script&lang=js&"
export * from "./ysZhiShi.vue?vue&type=script&lang=js&"
import style0 from "./ysZhiShi.vue?vue&type=style&index=0&id=51e2123c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e2123c",
  null
  
)

export default component.exports